import React, { useState, useEffect, useContext, useRef } from "react";
import { Modal } from "antd";
import "../Card/Card.css";

import openkit from "openkit";
import { API_URL } from "../../config/config";
import { ENTITIES } from "../../entities/entitiesConfig";
openkit.config.app_url = API_URL;

function ProductInfo({
  entity,
  store,
  productProp,
  product,
  isInfoVisible,
  setIsInfoVisible,
}) {
  // const [product, setProduct] = useState(null);

  // useEffect(() => {
  //   if (productProp) {
  //     // if productProp came from reservation_lines, it has a product_id field
  //     let id;
  //     id = productProp.product_id ? productProp.product_id : productProp.id;

  //     async function getProduct() {
  //       const product = await openkit.data.findOne("c_products", {
  //         id: id,
  //       });
  //       setProduct(product);
  //     }
  //     getProduct();
  //   }
  // }, []);

  return (
    <Modal
      visible={isInfoVisible}
      onOk={() => setIsInfoVisible(false)}
      onCancel={() => setIsInfoVisible(false)}
      footer={[]}
      width="auto"
      style={{ maxWidth: "600px" }}
      footer={null}
    >
      {entity && product && ENTITIES[entity].InfoContent({ product, store })}
    </Modal>
  );
}

export default ProductInfo;
